<div class="card">
    <p-toast />
    <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
        <div><h4><strong style=" margin-left:10px">Pending Vendor List</strong></h4></div>
        <div class="grid">
        <p-button *ngIf="isListView" label="Card View" (click)="cardView()" class="mr-2"/>
        <p-button *ngIf="isCardView" label="List View" (click)="listView()" class="mr-2"/>
        <!-- <button pButton type="button"  style="height:10px; margin-right: 10px; margin-top: -10px; background-color:#2c436b" ></button>    -->
        <p-button label="Report" icon="pi pi-download" (click)="downloadExcel()"/>
        </div>
    </div>
<hr>
    <div *ngIf="isCardView" class="grid">
        <div *ngFor="let vendor of vendorList">
            <div class="col">
                <app-vendor-detail-card  [vendor]="vendor"></app-vendor-detail-card>
            </div>
        </div>
    </div>
    <!-- <div *ngIf="isListView" style="display: flex; justify-content:end; margin-bottom:20px;">
        <p-button
            pRipple
            label="Approve"
            icon="pi pi-check"
            class="mr-2"
            (click)="openConfirmationDialog()"
            [disabled]="!selectedVendor"
           />
    </div> -->
        <p-table *ngIf="isListView" [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines"
        [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '100rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedVendor" >
        <ng-template pTemplate="header">
            <tr>
                <!-- <th style="width: 4rem" class="bg-orange">
                    <p-tableHeaderCheckbox />
                </th> -->
                <th class="bg-orange"></th>
                <th pSortableColumn="business_name" class="bg-orange">Name <p-sortIcon field="business_name"></p-sortIcon></th>
                <th pSortableColumn="vendor_code" class="bg-orange">Vendor Code <p-sortIcon field="vendor_code"></p-sortIcon></th>
                <th pSortableColumn="primary_address" class="bg-orange">Primary Address <p-sortIcon field="primary_address"></p-sortIcon></th>
                <!-- <th pSortableColumn="vendor_group">Vendor Group <p-sortIcon field="vendor_group"></p-sortIcon></th> -->
                <th pSortableColumn="city" class="bg-orange">City <p-sortIcon field="city"></p-sortIcon></th>
                <th pSortableColumn="state" class="bg-orange">State <p-sortIcon field="state"></p-sortIcon></th>
                <th pSortableColumn="country" class="bg-orange">Country <p-sortIcon field="country"></p-sortIcon></th>
                <th pSortableColumn="gstin" class="bg-orange">GSTIN Number <p-sortIcon field="gstin"></p-sortIcon></th>
                <th pSortableColumn="inventoryStatus" class="bg-orange">Status<p-sortIcon field="status"></p-sortIcon></th>
            </tr>
            <tr>
              <th></th>
              <th *ngFor="let col of cols">
                <ng-container *ngIf="col.field != 'state' && col.field != 'country'">
                  <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                </ng-container>
                  <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
              </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
              <td>
                  <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.get_user,vendor.status,vendor.business_name)" class="p-button-rounded" pTooltip="View Details"></button>
              </td>
              <td>{{ vendor.business_name }}</td>
              <td>{{ vendor.vendor_code }}</td>
              <td>{{ vendor.address_title }}</td>
              <!-- <td>{{ vendor.vendor_group }}</td> -->
              <td>{{vendor.city}}</td>
              <td>{{getStateLabel(vendor.state,vendor.country)}}</td>
              <td>{{getcountries(vendor.country)}}</td>
              <td>{{vendor.gstn}}</td>
              <td>{{vendor.status}}</td>

            </tr>
        </ng-template>
    </p-table>

    <div>
      <p-paginator
      [rows]="limit"
      [first]="(currentPage - 1) * limit"
      [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)"
      [rowsPerPageOptions]="[10, 20,30,50,100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
       />
  </div>

    <p-confirmDialog header="Confirm Approval" [visible]="false" [style]="{ 'width': '40%' }">
      <ng-template pTemplate="message">
    <div class="grid mb-0" >
        <div style="text-align: center" class="col-12">
            <strong>Are you sure you want to approve the selected vendors?</strong>
        </div>
        <div class="col-12" *ngIf="isPendingApproval1">
          <div class="grid" style="text-align: center;">
            <div class="col" >
                <!-- <label>Account Group</label> -->
                <input
                    pInputText
                    [(ngModel)]="accountgroup" placeholder="Account Group" style="width: 100%;" required/>
            </div>
            <div class="col">
                <!-- <label>Payment Term</label> -->
                <p-dropdown
                [options]="paymentterm"
                [(ngModel)]="paymentTerm"
                placeholder="Payment Term"
                [style]="{'width': '100%'}"
                optionLabel="name" [required]="true"/>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="isPendingApproval2">
          <div class="grid" style="text-align: center;">
            <div class="col">
                <!-- <label >Purchase Organnization</label> -->
                <input
                    [(ngModel)]="purchaseOrgannization"
                    pInputText
                    placeholder="Purchase Organnization"
                    style="width: 100%;" required/>
            </div>
            <div class="col">
                <!-- <label>With Holding Tax</label> -->
                <input
                    [(ngModel)]="withholdingtax"
                    pInputText
                    placeholder="With Holding Tax"
                    style="width: 100%;" required/>
            </div>
        </div>
    </div>
    </div>
      </ng-template>
      <ng-template pTemplate="footer">
          <div class="flex justify-content-end mt-0" >
              <button type="button" pButton label="Cancel" icon="pi pi-times"  (click)="closeConfirmationDialog()"></button>
              <button type="button" pButton label="Save" icon="pi pi-check"  (click)="approvedVendor()" [disabled]="!isFormValid()"></button>
          </div>
      </ng-template>
  </p-confirmDialog>


    <!-- <p-confirmDialog [style]="{ width: '450px' }" /> -->
</div>
